import React from 'react';
import { useQuery } from '@apollo/client';
import FetchActivityQuery from './FetchActivityQuery';

type result = {
  loading: boolean;
  activityData?: any;
};

interface ITrackerFetchActivityConnectorApolloProps {
  children: (result: result) => React.ReactElement;
  activityId: number;
}

export const TrackerFetchActivityConnectorApollo: React.FC<
  ITrackerFetchActivityConnectorApolloProps
> = ({ children, activityId }) => {
  const { loading, data, error } = useQuery(FetchActivityQuery, {
    variables: {
      id: activityId,
    },
  });

  const result: result = {
    loading,
  };

  if (error) {
    throw error;
  }

  if (!loading && data) {
    result.activityData = data.dailyTracker.activity;
  }

  return children(result);
};

export default TrackerFetchActivityConnectorApollo;
